import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsDetailsComponent } from './details/details.component';
import { SettingsSecurityComponent } from './security/security.component';
import { SettingsTemplatesComponent } from './templates/templates.component';
import { MatTabsModule, MatTabChangeEvent } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureFlagsService } from '../_services/feature-flags.service';
import { AnalyticsService, SettingsPageTab } from '../_services/analytics.service';


@Component({
  selector: 'app-settings',
  imports: [CommonModule, SettingsDetailsComponent, SettingsSecurityComponent, SettingsTemplatesComponent, MatTabsModule, TranslateModule],
  templateUrl: './settings.component.html',
  host: { class: 'block h-full p-4 md:px-10 md:pt-8 md:pb-14' },
})
export class SettingsComponent implements OnInit {
  private readonly analytics = inject(AnalyticsService);

  @ViewChild('tabContent') tabContent?: ElementRef<HTMLElement>;

  activeTab = 'my-details';

  get selectedIndex(): number {
    return this.tabs.findIndex(t => t.id === this.activeTab);
  }

  readonly tabs = [
    { id: 'my-details', label: 'My details' },
    { id: 'security', label: 'Security' },
    { id: 'templates', label: 'Blueprints' },
  ];

  constructor(private readonly flags: FeatureFlagsService) {
    this.tabs[2].label = this.flags.isEnabled('noteGenerationSettings') ? 'Blueprints & styles' : 'Blueprints';
  }

  ngOnInit(): void {
    this.trackSettingsPage(this.activeTab);
  }

  selectTab(tabId: string) {
    this.activeTab = tabId;
  }

  onTabChange(event: MatTabChangeEvent) {
    const tab = this.tabs[event.index];
    if (!tab || tab.id === this.activeTab) {
      this.resetTabScroll();
      return;
    }
    this.activeTab = tab.id;
    this.trackSettingsPage(tab.id);
    this.resetTabScroll();
  }

  private trackSettingsPage(tabId: string): void {
    const tab = this.settingsTab(tabId);
    if (!tab) return;
    this.analytics.track('settings_page_viewed', { tab });
  }

  private settingsTab(tabId: string): SettingsPageTab | undefined {
    switch (tabId) {
      case 'my-details':
        return 'my_details';
      case 'security':
        return 'security';
      case 'templates':
        return 'blueprints_styles';
      default:
        return undefined;
    }
  }

  private resetTabScroll(): void {
    const el = this.tabContent?.nativeElement;
    if (el) {
      el.scrollTop = 0;
    }
  }
}
